import React from "react";
import "../styles/whyus.css";
import pizzaIcon from "../assets/pizza-icon.svg";

const ORDER_URL = "https://debrecenipizza.hu/";

export default function WhyUs() {
  return (
    <section className="whyus-section">
      <div className="container">
        <div className="row align-items-center p-4 p-lg-0">
          {/* Left: Image */}
          <div className="col-lg-6 p-lg-5">
            <div className="whyus-image-wrap pb-5 pb-lg-0">
              <img
                src="/images/whyus.webp"
                alt="Pizza Home különlegessége"
                className="whyus-image"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="col-lg-6 p-lg-5">
            <div className="whyus-content">
              <h2>
                Miben <span className="highlight">különbözik</span> a Pizza Home
                pizzája Debrecenben?
              </h2>

              <p>
                Ismered azt az érzést, amikor beleharapsz egy extra vékony,
                roppanós tésztájú pizzába, ami tele van friss, ízletes
                feltétekkel? Pont ezt kínálja a Pizza Home Debrecen! A jól
                bevált receptjeinkkel és minőségi alapanyagokkal dolgozunk, így
                akár munkahelyi ebédre, akár egy nyugodt esti vacsorára
                rendelsz, mindig ugyanazt a finom, megbízható minőséget kapod.
              </p>

              <ul className="whyus-list">
                <li>
                  <img src={pizzaIcon} alt="" className="icon" />A tésztát
                  minden alkalommal nyújtógéppel készítjük egyenletes
                  vastagságúra, így választhatsz az intenzívebb, roppanós 1
                  mm-es vagy a laktatóbb 2 mm-es pizzatészta között.
                </li>

                <li>
                  <img src={pizzaIcon} alt="" className="icon" />
                  Ha egészségesebb alternatívára vágysz, pizzáink elérhetők
                  teljes kiőrlésű tésztával is — így könnyen beilleszthetők a
                  tudatos étrendbe.
                </li>

                <li>
                  <img src={pizzaIcon} alt="" className="icon" />A pizzatésztát
                  mindig körbevágjuk, hogy ne maradjon vastag szél — így minden
                  falat tele van feltéttel. A paradicsomos alapra először a
                  sajtot tesszük, majd erre kerülnek a feltétek, így pizzáink
                  nemcsak finomak, hanem látványra is tökéletesek, amikor házhoz
                  visszük őket.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* CTA button */}
        <div className="whyus-cta justify-content-center text-center mt-4">
          <a href={ORDER_URL} className="btn-order">
            Hamarosan &gt;&gt;
          </a>
        </div>
      </div>
    </section>
  );
}
